import React, { useMemo, useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";

// This is a select component for UTC timezones used in multiple forms.
const TimezoneSelect = ({
  name = "ianatimezonecode",
  value,
  onChange,
  className = "",
  id = "time_zone",
  placeholder = "Time Zone",
  disabled = false,
}) => {
  // The list runs to a hundred-odd entries, so scrolling it to find one is
  // slower than typing three letters of the city.
  const [search, setSearch] = useState("");
  const timezones = [
    {
      value: "Pacific/Midway",
      label: "(UTC-11:00) Midway Island, American Samoa",
    },
    { value: "Pacific/Honolulu", label: "(UTC-10:00) Hawaii" },
    { value: "America/Anchorage", label: "(UTC-08:00) Alaska" },
    {
      value: "Pacific/Midway",
      label: "(UTC-11:00) Midway Island, American Samoa",
    },
    { value: "Pacific/Honolulu", label: "(UTC-10:00) Hawaii" },
    { value: "America/Anchorage", label: "(UTC-08:00) Alaska" },
    {
      value: "America/Tijuana",
      label: "(UTC-07:00) Baja California",
    },
    {
      value: "America/Los_Angeles",
      label: "(UTC-07:00) Pacific Time (US and Canada)",
    },
    { value: "America/Phoenix", label: "(UTC-07:00) Arizona" },
    {
      value: "America/Chihuahua",
      label: "(UTC-06:00) Chihuahua, La Paz, Mazatlan",
    },
    {
      value: "America/Denver",
      label: "(UTC-06:00) Mountain Time (US and Canada)",
    },
    { value: "America/Belize", label: "(UTC-06:00) Central America" },
    {
      value: "America/Chicago",
      label: "(UTC-05:00) Central Time (US and Canada)",
    },
    {
      value: "America/Mexico_City",
      label: "(UTC-05:00) Guadalajara, Mexico City, Monterrey",
    },
    { value: "America/Regina", label: "(UTC-06:00) Saskatchewan" },
    {
      value: "America/Bogota",
      label: "(UTC-05:00) Bogota, Lima, Quito",
    },
    {
      value: "America/Jamaica",
      label: "(UTC-05:00) Kingston, George Town",
    },
    {
      value: "America/New_York",
      label: "(UTC-04:00) Eastern Time (US and Canada)",
    },
    {
      value: "America/Indiana/Indianapolis|UTC-04:00",
      label: "(UTC-04:00) Indiana (East)",
    },
    { value: "America/Caracas", label: "(UTC-04:30) Caracas" },
    { value: "America/Asuncion", label: "(UTC-03:00) Asuncion" },
    {
      value: "America/Halifax",
      label: "(UTC-03:00) Atlantic Time (Canada)",
    },
    { value: "America/Cuiaba", label: "(UTC-04:00) Cuiaba" },
    {
      value: "America/Manaus",
      label: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
    },
    {
      value: "America/St_Johns",
      label: "(UTC-02:30) Newfoundland and Labrador",
    },
    { value: "America/Sao_Paulo", label: "(UTC-03:00) Brasilia" },
    {
      value: "America/Buenos_Aires",
      label: "(UTC-03:00) Buenos Aires",
    },
    {
      value: "America/Cayenne",
      label: "(UTC-03:00) Cayenne, Fortaleza",
    },
    { value: "America/Godthab", label: "(UTC-02:00) Greenland" },
    { value: "America/Montevideo", label: "(UTC-03:00) Montevideo" },
    { value: "America/Bahia", label: "(UTC-03:00) Salvador" },
    { value: "America/Santiago", label: "(UTC-03:00) Santiago" },
    { value: "America/Noronha", label: "(UTC-02:00) Mid-Atlantic" },
    { value: "Atlantic/Azores", label: "(UTC+00:00) Azores" },
    {
      value: "Atlantic/Cape_Verde",
      label: "(UTC-01:00) Cape Verde Islands",
    },
    {
      value: "Europe/London",
      label: "(UTC+01:00) Dublin, Edinburgh, Lisbon, London",
    },
    { value: "Africa/Casablanca", label: "(UTC+01:00) Casablanca" },
    {
      value: "Africa/Monrovia",
      label: "(UTC+00:00) Monrovia, Reykjavik",
    },
    {
      value: "Europe/Amsterdam",
      label: "(UTC+02:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    },
    {
      value: "Europe/Belgrade",
      label: "(UTC+02:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    },
    {
      value: "Europe/Brussels",
      label: "(UTC+02:00) Brussels, Copenhagen, Madrid, Paris",
    },
    {
      value: "Europe/Warsaw",
      label: "(UTC+02:00) Sarajevo, Skopje, Warsaw, Zagreb",
    },
    {
      value: "Africa/Algiers",
      label: "(UTC+01:00) West Central Africa",
    },
    { value: "Africa/Windhoek", label: "(UTC+02:00) Windhoek" },
    {
      value: "Europe/Athens",
      label: "(UTC+03:00) Athens, Bucharest",
    },
    { value: "Asia/Beirut", label: "(UTC+03:00) Beirut" },
    { value: "Africa/Cairo", label: "(UTC+02:00) Cairo" },
    { value: "Asia/Damascus", label: "(UTC+03:00) Damascus" },
    { value: "EET|UTC+03:00", label: "(UTC+03:00) Eastern Europe" },
    { value: "Africa/Harare", label: "(UTC+02:00) Harare, Pretoria" },
    {
      value: "Europe/Helsinki",
      label: "(UTC+03:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius",
    },
    { value: "Asia/Istanbul", label: "(UTC+03:00) Istanbul" },
    { value: "Asia/Jerusalem", label: "(UTC+03:00) Jerusalem" },
    { value: "Europe/Kaliningrad", label: "(UTC+02:00) Kaliningrad" },
    { value: "Africa/Tripoli", label: "(UTC+02:00) Tripoli" },
    { value: "Asia/Amman", label: "(UTC+03:00) Amman" },
    { value: "Asia/Baghdad", label: "(UTC+03:00) Baghdad" },
    { value: "Asia/Kuwait", label: "(UTC+03:00) Kuwait, Riyadh" },
    { value: "Europe/Minsk", label: "(UTC+03:00) Minsk" },
    {
      value: "Europe/Moscow",
      label: "(UTC+03:00) Moscow, St. Petersburg, Volgograd",
    },
    { value: "Africa/Nairobi", label: "(UTC+03:00) Nairobi" },
    { value: "Asia/Tehran", label: "(UTC+03:30) Tehran" },
    { value: "Asia/Muscat", label: "(UTC+04:00) Abu Dhabi, Muscat" },
    { value: "Asia/Baku", label: "(UTC+05:00) Baku" },
    { value: "Europe/Samara", label: "(UTC+04:00) Izhevsk, Samara" },
    { value: "Indian/Mauritius", label: "(UTC+04:00) Port Louis" },
    { value: "Asia/Tbilisi", label: "(UTC+04:00) Tbilisi" },
    { value: "Asia/Yerevan", label: "(UTC+04:00) Yerevan" },
    { value: "Asia/Kabul", label: "(UTC+04:30) Kabul" },
    {
      value: "Asia/Tashkent",
      label: "(UTC+05:00) Tashkent, Ashgabat",
    },
    {
      value: "Asia/Yekaterinburg",
      label: "(UTC+05:00) Ekaterinburg",
    },
    {
      value: "Asia/Karachi",
      label: "(UTC+05:00) Islamabad, Karachi",
    },
    {
      value: "Asia/Kolkata",
      label: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    },
    {
      value: "Asia/Colombo",
      label: "(UTC+05:30) Sri Jayawardenepura",
    },
    { value: "Asia/Katmandu", label: "(UTC+05:45) Kathmandu" },
    { value: "Asia/Almaty", label: "(UTC+06:00) Astana" },
    { value: "Asia/Dhaka", label: "(UTC+06:00) Dhaka" },
    { value: "Asia/Novosibirsk", label: "(UTC+06:00) Novosibirsk" },
    { value: "Asia/Rangoon", label: "(UTC+06:30) Yangon (Rangoon)" },
    {
      value: "Asia/Bangkok",
      label: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
    },
    { value: "Asia/Krasnoyarsk", label: "(UTC+07:00) Krasnoyarsk" },
    {
      value: "Asia/Chongqing",
      label: "(UTC+08:00) Beijing, Chongqing, Hong Kong SAR, Urumqi",
    },
    { value: "Asia/Irkutsk", label: "(UTC+08:00) Irkutsk" },
    {
      value: "Asia/Kuala_Lumpur",
      label: "(UTC+08:00) Kuala Lumpur, Singapore",
    },
    { value: "Australia/Perth", label: "(UTC+08:00) Perth" },
    { value: "Asia/Taipei", label: "(UTC+08:00) Taipei" },
    { value: "Asia/Ulaanbaatar", label: "(UTC+08:00) Ulaanbaatar" },
    {
      value: "Asia/Tokyo",
      label: "(UTC+09:00) Osaka, Sapporo, Tokyo",
    },
    { value: "Asia/Seoul", label: "(UTC+09:00) Seoul" },
    { value: "Asia/Yakutsk", label: "(UTC+09:00) Yakutsk" },
    { value: "Australia/Adelaide", label: "(UTC+10:30) Adelaide" },
    { value: "Australia/Darwin", label: "(UTC+09:30) Darwin" },
    { value: "Australia/Brisbane", label: "(UTC+10:00) Brisbane" },
    {
      value: "Australia/Canberra",
      label: "(UTC+11:00) Canberra, Melbourne, Sydney",
    },
    {
      value: "Pacific/Guam",
      label: "(UTC+10:00) Guam, Port Moresby",
    },
    { value: "Australia/Hobart", label: "(UTC+11:00) Hobart" },
    { value: "Asia/Magadan", label: "(UTC+10:00) Magadan" },
    {
      value: "Asia/Vladivostok",
      label: "(UTC+10:00) Vladivostok, Magadan",
    },
    { value: "Asia/Srednekolymsk", label: "(UTC+11:00) Chokirdakh" },
    {
      value: "Pacific/Guadalcanal",
      label: "(UTC+11:00) Solomon Islands, New Caledonia",
    },
    {
      value: "Asia/Anadyr",
      label: "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky",
    },
    {
      value: "Pacific/Auckland",
      label: "(UTC+13:00) Auckland, Wellington",
    },
    {
      value: "Pacific/Fiji",
      label: "(UTC+12:00) Fiji Islands, Kamchatka, Marshall Islands",
    },
    { value: "Pacific/Tongatapu", label: "(UTC+13:00) Nuku'alofa" },
    { value: "Pacific/Apia", label: "(UTC+14:00) Samoa" },
    { value: "Pacific/Apia", label: "(UTC+14:00) Samoa" },
  ];

  const seenTimezones = new Set();
  const timezoneOptions = timezones.filter((timezone) => {
    if (seenTimezones.has(timezone.value)) return false;
    seenTimezones.add(timezone.value);
    return true;
  });

  const handleValueChange = (nextValue) => {
    onChange?.({
      target: {
        id,
        name,
        value: nextValue,
      },
    });
  };

  const matching = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return timezoneOptions;
    return timezoneOptions.filter(
      ({ value, label }) =>
        label.toLowerCase().includes(query) || value.toLowerCase().includes(query),
    );
  }, [search, timezoneOptions]);

  return (
    <Select
      name={name}
      value={value || ""}
      onValueChange={handleValueChange}
      // Clear the filter on close so the next open starts from the full list.
      onOpenChange={(open) => !open && setSearch("")}
    >
      <SelectTrigger id={id} className={className} disabled={disabled}>
        <SelectValue
          placeholder={`~ Please select a ${placeholder.toLowerCase()} ~`}
        />
      </SelectTrigger>
      <SelectContent>
        <div className="sticky top-0 z-10 bg-popover p-2">
          <input
            className="h-8 w-full rounded-md border border-input bg-background px-2 text-sm"
            placeholder="Type a city or offset..."
            value={search}
            aria-label="Search time zones"
            onChange={(event) => setSearch(event.target.value)}
            // The select steals keystrokes for its own type-ahead otherwise, so
            // typing would jump the highlight instead of filtering.
            onKeyDown={(event) => event.stopPropagation()}
          />
        </div>
        {matching.length === 0 ? (
          <p className="px-3 py-4 text-sm text-muted-foreground">
            No time zone matches "{search}".
          </p>
        ) : (
          matching.map(({ value, label }) => (
            <SelectItem key={value} value={value}>
              {label}
            </SelectItem>
          ))
        )}
      </SelectContent>
    </Select>
  );
};

export default TimezoneSelect;
